import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import VueTranslate from 'vue-translate-plugin';

Vue.use(Vuetify);
Vue.use(VueTranslate);

export default new Vuetify({
});
